module.exports = __webpack_public_path__ + "static/media/AvenirNext-HeavyItalic.f104503f.woff";